const WEBSITE = { name: "", url: "" };
const YOUTUBE_CHANNEL = { youtubeId: 0, title: "", url: "" };

import User from "./User";
export default class Creator {
  constructor({
    id,
    user,
    firstName,
    description,
    profilePicture,
    websites,
    youtubeChannels,
    instagramUrl,
    facebookUrl,
    twitterUrl,
    pinterestUrl,
    themes,
    departments,
    isSelected,
    postsCount,
    destinationsCount
  } = {}) {
    this.firstName = firstName || "";
    this.id = id || 0;
    this.user = new User(user) || new User();
    this.profilePicture = profilePicture || null;
    this.description = description || "";
    this.websites = websites || [];
    this.youtubeChannels = youtubeChannels || [];
    this.instagramUrl = instagramUrl || "";
    this.facebookUrl = facebookUrl || "";
    this.twitterUrl = twitterUrl || "";
    this.pinterestUrl = pinterestUrl || "";
    this.themes = themes || [];
    this.departments = departments || [];
    this.isSelected = isSelected || false;
    this.postsCount = postsCount || 0;
    this.destinationsCount = destinationsCount || 0;
  }
  getCreatorDataForEditAPI = () => ({
    firstName: this.user.firstName,
    description: this.description,
    websites: this.websites,
    youtubeChannelUrls: this.youtubeChannels.map(x => x.url),
    instagramUrl: this.instagramUrl,
    facebookUrl: this.facebookUrl,
    twitterUrl: this.twitterUrl,
    pinterestUrl: this.pinterestUrl,
    profilePicture: this.profilePicture
  });
  addWebsite() {
    this.websites.push({ ...WEBSITE });
  }
  removeWebsite(index) {
    this.websites.splice(index, 1);
  }
  addYoutubeChannel() {
    this.youtubeChannels.push({ ...YOUTUBE_CHANNEL });
  }
  removeYoutubeChannel(index) {
    this.youtubeChannels.splice(index, 1);
  }
  getUserDataForEditAPI() {
    return {
      username: this.user.username,
      email: this.user.email
    };
  }
  setUserData(data) {
    this.user.email = data.email;
    this.user.username = data.username;
  }
}
